module.exports = __webpack_public_path__ + "img/logo4.f3e10a57.png";